import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  .page-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .page-bg-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
    }

    .page-bg-image-mask {
      width: 100%;
      height: 444px;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
    }
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }

    .app-logo {
      margin: 0 0 30px;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;

      .page-footer-button {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 12px;
      }
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    margin: 0 0 20px;
    font-weight: 600;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
    background: linear-gradient(136deg, #7f36f3 -3.67%, #ed0d80 106.36%);
    background-clip: text;
  }
`;
